import { Toggle, TooltipV2 } from '@cimplico/components';
import { CWTSchemaTable } from '../../../../types/custom-worksheet-v2';
import { canSummarise, sortByOrder } from '../../store/utils';
import { formatMixedCase } from '../../../../utilities/formatting';
import { editTableColumnSummary } from '../../store/slice';
import { useDispatch } from 'react-redux';
import { getReference } from '../../../../components/custom-worksheet/utils';

type SummaryRowsProps = {
    table: CWTSchemaTable;
};

function SummaryRows({ table }: SummaryRowsProps): JSX.Element {
    const dispatch = useDispatch();

    return (
        <div className="pl-4">
            {sortByOrder(table.properties.row.properties).map((column) => {
                const tableColumnReference = getReference(column.id);
                const tableSummary = table.summary?.properties || {};
                const defaultToggled =
                    Object.keys(tableSummary).find((ref) => ref === tableColumnReference) !== undefined &&
                    tableSummary[getReference(column.id)] !== null;

                return (
                    <div className="flex items-start justify-between py-1" key={column.id}>
                        <p className="text-gray-700 text-xs font-medium">{column.name}</p>
                        <div>
                            <TooltipV2
                                message={`${formatMixedCase(column.type)} cannot be summarised`}
                                disabled={canSummarise(column.type)}
                            >
                                <Toggle
                                    type="short"
                                    isDisabled={!canSummarise(column.type)}
                                    defaultEnabled={defaultToggled}
                                    onToggle={(): void => {
                                        dispatch(editTableColumnSummary({ id: column.id, value: { enabled: !defaultToggled } }));
                                    }}
                                />
                            </TooltipV2>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default SummaryRows;
